export const dataUtil = {
    getImageByUsageTypePortal,
    createItemsWithComponents
};
export const usage_type = {
    offers: 'IMAGE',
    offers_merchant: 'APP_LOGO',
    offer_detail: 'IMAGE',
    offer_detail_merchant: 'APP_LOGO',
    offer_map: 'IMAGE',
    offer_map_merchant: 'APP_LOGO',
    offer_order: 'IMAGE',
    product_item: 'IMAGE',
    product_detail: 'IMAGE',
    refer_friend: 'MARKETING',
    catalog: 'IMAGE',
    business_logo: 'BUSINESS_APP_LOGO',
    wallet_image: "WALLET_IMAGE",
    landing_page_bg: "LANDING_PAGE_IMAGE",
    delivery_image: "DELIVERY_IMAGE",
    pickup_image: "PICKUP_IMAGE",
    direct_sale_image: "DIRECT_SALE_IMAGE",
    APP_LOGO: "APP_LOGO",
    merchants_image: 'APP_LOGO',
    carousel_image: 'CAROUSEL',
    carousel_image: 'CAROUSEL',
    profile_image: 'AVATAR',
    promotions: "IMAGE"
}

export const preferences_type = {
    order: "ORDERS",
    rewards: "REWARDS"
}

function getImageByUsageTypePortal(creatives, type, ignoreFirstElement) {
    let imageSources = [];
    let creative = null;
    if (!creatives || creatives.length == 0)
        return [];
    var isExitType = false;
    if (type) {
        creatives.forEach(element => {
            if (element.usage_type && element.usage_type.toLowerCase() === type.toLowerCase()) {
                creative = element;
                isExitType = true;
            }
        });
    }
    if (!isExitType && !ignoreFirstElement) {
        creative = creatives[0];
    }
    if (creative) {
        let media = creative.media;
        if (media && media.length > 0) {
            media.forEach(m => {
                if (m.width > 50 && m.height > 50) {
                    imageSources.push({
                        url: m.url,
                        width: m.width,
                        height: m.height
                    })
                }
            });
        } else {
            imageSources.push({
                url: creative.url,
                width: creative.width,
                height: creative.height
            })
        }
    }
    return imageSources.length > 0 ? imageSources[0] : null;
}


function createItemsWithComponents(items) {
    let _items = [];
    if (items && items.length > 0) {
        let mainProducts = items.filter(item => {
            return item.product && !item.product.bundled_item
        })
        if (mainProducts.length > 0) {
            mainProducts.forEach(p => {
                let mainProduct = {...p};
                let product = {...mainProduct.product};
                let bundleProducts = items.filter(item => {
                    let bundled_item_product = item.product && item.product.bundled_item && item.product.bundled_item.product;
                    return bundled_item_product && bundled_item_product.id == product.id;
                })
                if (bundleProducts && bundleProducts.length > 0) {
                    product.components = createObjComponent(bundleProducts);
                    mainProduct.product = product;
                }
                _items.push(mainProduct);
            });
        }
    }
    return _items;
}

function createObjComponent(components){
    let _components = [];
    components.forEach(element => {
        let object = {...element.product};
        object.price = element.sub_total;
        object.quantity = element.quantity;
        _components.push(object);
    });
    return _components
}